import { createFileRoute, Outlet } from "@tanstack/react-router";
import { EditContent } from "@/features/consent-solutions";

const Route = createFileRoute("/_authorized/consent-solutions/$csId/cookie-management")({
  component: () => (
    <EditContent fullWidth>
      <Outlet />
    </EditContent>
  ),
});

export { Route };
